var _polyline, _polyline2, _line, _line2, _line3, _line4, _polyline3, _line5, _line6, _line7, _line8, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBathShowerConversion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bath-shower-conversion",
    viewBox: "0 0 163.7 178.4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "161.9 18.3 161.9 176.7 1.8 176.7 1.8 18.3",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "1.8 176.7 14.4 161.8 14.4 18.3",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.4,
    x2: 28.9,
    y1: 85.5,
    y2: 85.5,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4,
    x2: 28.9,
    y1: 106.8,
    y2: 106.8,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4,
    x2: 28.9,
    y1: 128.1,
    y2: 128.1,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4,
    x2: 28.9,
    y1: 149.3,
    y2: 149.3,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "161.9 176.7 149.3 161.8 149.3 18.3",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 149.3,
    x2: 134.8,
    y1: 85.5,
    y2: 85.5,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 149.3,
    x2: 134.8,
    y1: 106.8,
    y2: 106.8,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 149.3,
    x2: 134.8,
    y1: 128.1,
    y2: 128.1,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 149.3,
    x2: 134.8,
    y1: 149.3,
    y2: 149.3,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5675
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.5 5.6h-27.7c-1.1 0-2 0.9-2 2v5.1",
    fill: "none",
    strokeWidth: 2.2748
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.9 13.7h-5v-0.1c0-1.3-1.4-2.4-3.1-2.4s-3.1 1.1-3.1 2.4v0.1h-5c-0.9 0-1.7 0.8-1.7 1.7v5.3h19.6v-5.3c0-0.9-0.7-1.7-1.7-1.7z",
    fill: "#fff",
    strokeWidth: 2.2748
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.8,
    cy: 21.4,
    rx: 9.9,
    ry: 2.8,
    fill: "#fff",
    strokeWidth: 2.2748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,1v9.7c-2.6,0-4.8-2.2-4.8-4.8S144,1,146.7,1z",
    fill: "#fff",
    strokeWidth: 1.9498
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 26.6,
    width: 2.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 35.1,
    width: 2.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 43.7,
    width: 2.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.1338 -.991 .991 .1338 65.108 133.18)",
    x: 106.1,
    y: 28.1,
    width: 5.3,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.1339 -.991 .991 .1339 55.747 139.35)",
    x: 105,
    y: 36.6,
    width: 5.3,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.134 -.991 .991 .134 46.394 145.52)",
    x: 103.8,
    y: 45,
    width: 5.3,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9939 -.1107 .1107 .9939 -2.521 13.247)",
    x: 116.8,
    y: 26.7,
    width: 2.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9939 -.1102 .1102 .9939 -3.4391 13.338)",
    x: 117.7,
    y: 35.1,
    width: 2.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9939 -.1102 .1102 .9939 -4.3659 13.493)",
    x: 118.7,
    y: 43.6,
    width: 2.4,
    height: 5.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathShowerConversion);
export default __webpack_public_path__ + "static/media/bath-shower-conversion.78e6ca9ad33c2aaf0794a5678be037a3.svg";
export { ForwardRef as ReactComponent };